import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M98.64 50c0 12.088-9.798 21.887-21.887 21.887H63.374a3.65 3.65 0 0 1-3.648-3.647 3.65 3.65 0 0 1 3.648-3.648h13.379c8.057 0 14.591-6.535 14.591-14.592S84.81 35.408 76.753 35.408H63.374a3.649 3.649 0 0 1 0-7.295h13.379c12.088 0 21.887 9.798 21.887 21.887M36.626 64.592a3.65 3.65 0 0 1 3.648 3.648 3.65 3.65 0 0 1-3.648 3.647H23.238A21.876 21.876 0 0 1 1.36 50.008v-.017a21.873 21.873 0 0 1 21.878-21.878h13.388a3.649 3.649 0 0 1 0 7.295H23.238a14.58 14.58 0 0 0-10.31 4.273 14.58 14.58 0 0 0-4.272 10.31v.017c0 3.868 1.536 7.58 4.272 10.31a14.58 14.58 0 0 0 10.31 4.274zm-5.471-10.944A3.647 3.647 0 0 1 27.507 50a3.646 3.646 0 0 1 3.648-3.648h37.696a3.648 3.648 0 1 1 0 7.296z"
    }, null, -1)
  ])))
}
export default { render: render }